<template>
<div>
  <div class="container-fluid">
    <div class="row mt17">
      <div class="col-sm-12">
        <div class="flex title-action">
          <h3></h3>
          <div class="flex">
            <donapp-button class="gradient-merchant btn-sm" :text="$t('labels.refresh')" :action="refresh" />
          </div>
        </div>
      </div>
    </div>
    <data-table
      title="POS"
      ref="posDevicesTable"
      :tableHeaders="tableHeaders"
      :radioFilter="radioFilter"
      :getData="getDevices"
      :options="options"/>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import DonappButton from '@/components/shared/buttons/Button'
import DataTable from '@/components/shared/dataTable/DataTable'
import apiService from '@/services/ApiService'
import logoDonapp from '@/assets/logo_donapp_light_blue.png'
import { posDevices as posDevicesTable } from '@/components/merchants/tables/settings'

export default {
  name: 'merchant-pos-devices',
  components: {
    DataTable,
    DonappButton
  },
  data() {
    return {
      ...posDevicesTable,
      logo: logoDonapp,
      loading: false,
      options: {
        hasDatesFilter: false,
        hasDateRange: false,
        hasSearch: true,
        hasAdvancedSearch: false,
        showCardHeader: true
      }
    }
  },
  methods: {
    getDevices: function(page, filters) {
      return apiService.getPosDevices({ page: page - 1, ...filters })
    },
    refresh() {
      this.$refs.posDevicesTable.refresh()
    }
  },
  computed: {
    ...mapState({
      merchant: state => state.user.loggedRole.merchant
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.title-action {
  justify-content: space-between;
  align-items: center;
}

h3,
.h3 {
  @include biggestFontSize();
  font-weight: 700;
  line-height: 21px;
  margin-top: 0px;
  margin-bottom: 0px;
  cursor: default;
}

i {
  padding: 1px;
  cursor: pointer;
}

.private-key {
  align-items: flex-end;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/POS.vue